import { CurrencyPipe, DecimalPipe, I18nPluralPipe } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { LoadingContainerComponent } from 'common-ui';
import { ItemPriceComponentStore } from 'products-data';
import { CommonItemComponentBase } from '../../CommonItemComponentBase';
import { CallForPriceButtonComponent } from '../call-for-price-button';

@Component({
  selector: 'ideal-product-price-simple',
  imports: [LoadingContainerComponent, CurrencyPipe, DecimalPipe, I18nPluralPipe, CallForPriceButtonComponent],
  standalone: true,
  templateUrl: './product-price-simple.component.html',
  styleUrl: './product-price-simple.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ItemPriceComponentStore],
  host: {
    '[class.sale]': 'isSale()',
    '[class.show-units]': '!hideUnits()',
  },
})
export class ProductPriceSimpleComponent extends CommonItemComponentBase {
  public readonly hideUnits = input(false, { transform: booleanAttribute });
  private readonly _priceStore = inject(ItemPriceComponentStore);

  protected readonly pricingLoading = this._priceStore.itemPricing.loading;
  // protected readonly pricingError = this._priceStore.error;
  // protected readonly pricingSuccess = this._priceStore.success;
  private readonly pricing = computed(() => this._priceStore.itemPricing()?.pricing);

  protected readonly callForPricing = computed(() => this.pricing()?.isCallForPricing);
  protected readonly priceNormalized = computed(() => this.pricing()?.pricePerSoldIn);
  protected readonly unitLabel = computed(() => this.pricing()?.unitLabelLocalized ?? {});
  protected readonly isSale = computed(() => this.pricing()?.isOnSale);
  protected readonly isSaleLimited = computed(() => this.pricing()?.isOnSaleLimited);

  protected readonly mainPrice = computed(() => ({
    priceBase: this.pricing()?.pricePerSoldInRegular,
    price: this.pricing()?.pricePerSoldIn,
    pricePer: this.pricing()?.quantitySoldIn,
    isSale: this.pricing()?.isOnSale,
  }));

  constructor() {
    super();
    effect(() => this._priceStore.selectItemById(this.itemId()));
  }
}
